const styles = {
    label: {
        fontFamily: 'Silka_Semi_Bold',
        marginBottom: '8px',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
    },
    autoComplete: {
        width: '100%',
    },
    item: {
        fontSize: 14,
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        lineHeight: '21px',
        padding: '12px',
        color: '#001533',
    },
    placeholder: {
        fontSize: 14,
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        lineHeight: '21px',
        color: '#a2a2a2',
    },
    error_message: {
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
};
export default styles;
